import React from 'react';

import { SkeletonLoader, SkeletonText, Text } from '@zapier/design-system';

import { useDebouncedValue, usePartnerProfile } from 'app/developer-v3/hooks';

import Profile from './Profile';

function Container() {
  const {
    isLoading,
    partnerProfile,
    updatePartnerProfile,
  } = usePartnerProfile();

  const [isLoadingDebounced] = useDebouncedValue(isLoading, 1500);

  return (
    <section>
      <Text margin="0px 0px 25px 0px" tag="h1" type="SectionHeader">
        Profile Settings
      </Text>
      {isLoadingDebounced ? (
        <SkeletonLoader>
          <SkeletonText lines={2} size="heading" width="80%" />
        </SkeletonLoader>
      ) : (
        <Profile
          initialPartnerProfile={partnerProfile}
          onUpdate={updatePartnerProfile}
        />
      )}
    </section>
  );
}

export default Container;
